import axios from 'axios'
import {
    ConfigurationPersonnelSampleTypeAssignmentCreateRequest,
    ConfigurationPersonnelSampleTypeAssignmentResponse
} from '@/modules/configurationModule/detail/automation/personnel/entities-association/services/configuration-personnel-sample-type-assignment/configuration-personnel-sample-type-assignment.dto'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

class ConfigurationPersonnelSampleTypeAssignmentService {
    async create(laboratoryId: number, request: ConfigurationPersonnelSampleTypeAssignmentCreateRequest): Promise<ConfigurationPersonnelSampleTypeAssignmentResponse> {
        const response = await axios.post<ConfigurationPersonnelSampleTypeAssignmentResponse>(`/configuration/laboratories/${laboratoryId}/personnelSampleTypeAssignments`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPersonnelSampleTypeAssignmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPersonnelSampleTypeAssignmentResponse>>(`/configuration/laboratories/${laboratoryId}/personnelSampleTypeAssignments`, { ...filterModel }, { params })
        return response.data
    }

    async delete(personnelSampleTypeAssignmentId: number, laboratoryId: number): Promise<void> {
        const response = await axios.delete<void>(`/configuration/laboratories/${laboratoryId}/personnelSampleTypeAssignments/${personnelSampleTypeAssignmentId}`)
        return response.data
    }
}

export const configurationPersonnelSampleTypeAssignmentService = new ConfigurationPersonnelSampleTypeAssignmentService()
